import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-column">
          <h4>FIND US</h4>
          <p>Hong Kong Ruijingsheng Trading Co., Limited</p>
          <p>
            RM 12, UNIT 12A, 13/F, BLOCK 1,<br />
            CAMEL PAINT BUILDING,<br />
            62 HOI YUEN ROAD,<br />
            KWUN TONG, HONG KONG
          </p>
          <p>
            Email: <a href="mailto:model@baplehollow.online">model@baplehollow.online</a>
          </p>
        </div>

        <div className="footer-column">
          <h4>CUSTOMER SERVICE</h4>
          <ul>
            <li>
              <Link to="/shipping">Shipping</Link>
            </li>
            <li>
              <Link to="/returns">Returns & Refunds</Link>
            </li>

            <li>
              <Link to="/privacy">Privacy</Link>
            </li>
            <li>
              <Link to="/terms">Terms & Conditions</Link>
            </li>
            <li>
              <Link to="/cookies">Cookie Policy</Link>
            </li>
            <li>
              <Link to="/faqs">FAQs</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
          </ul>
        </div>

        <div className="footer-column logo-column">
          <div
            className="footer-logo-circle"
            onClick={toTop}
            style={{ cursor: "pointer" }}
          >
            <span>
              baple
              <br />
              hollow
            </span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="copyright">
          &copy; 2026 baplehollow. All rights reserved.
        </div>
        <div className="payment-icons" aria-label="Supported payment methods">
          <span className="payment-badge visa">VISA</span>
          <span className="payment-badge mastercard" aria-label="Mastercard">
            <span className="mc-red" /><span className="mc-orange" />
          </span>
          <span className="payment-badge amex">AMEX</span>
          <span className="payment-badge union-pay">UnionPay</span>
          <span className="payment-badge apple-pay">Apple Pay</span>
          <span className="payment-badge google-pay">G Pay</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
